import styled, { css } from 'styled-components';

// @ts-ignore
import promoMark from '../../../assets/img/check-promo.svg';
// @ts-ignore
import checkMark from '../../../assets/img/check-white.svg';
import { COLORS } from '../../../tokens/colors';
import { checkboxSizes, getSizes, TControlSize } from '../baseControlsData';

import { TCheckboxType } from './index';

const BORDER_WIDTH = 2;

const getCheckboxSizes = (size: TControlSize) => getSizes(size, checkboxSizes);

type IStyleProps = {
    size: TControlSize,
    checkType: TCheckboxType,
    invertColor?: boolean,
    disabled: boolean,
    withLabel: boolean,
}

export const Label = styled.label<IStyleProps>`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin: 0;
    padding: 0;
    ${p => getCheckboxSizes(p.size).font};
    color: ${({ disabled, invertColor }) =>
        disabled
            ? COLORS.TextDisabled
                : invertColor
                ? COLORS.TextWhite
            : COLORS.TextPrimary };
    user-select: none;
    cursor: ${p => p.disabled ? 'initial' : 'pointer'};

    input[type="checkbox"] {
        appearance: none;
        position: relative;
        flex: 0 0 auto;
        width: ${p => getCheckboxSizes(p.size).inputSize}px;
        height: ${p => getCheckboxSizes(p.size).inputSize}px;
        margin: 0;
        margin-right: ${p => p.withLabel ? getCheckboxSizes(p.size).rMargin + 'px' : 0 };
        padding: 0;
        background-color: ${COLORS.BgMain};
        border-width: ${BORDER_WIDTH}px;
        border-style: solid;
        border-color: ${COLORS.Brand_Blue};
        border-radius: 6px;
        transition: .3s;
        outline: none;
        box-sizing: border-box;
        cursor: inherit;

        @media (hover: hover) {
            &:hover {
                border-color: ${COLORS.Link};
            }
        }

        &:required:invalid {
            border-color: ${COLORS.Error};
            background-color: ${COLORS.BgError};

            @media (hover: hover) {
                &:hover {
                    border-color: ${COLORS.Link};
                    background-color: ${COLORS.BgMain};
                }
            }
        }

        &:disabled {
            border-color: ${COLORS.GRAY_LIGHT};
            background-color: ${COLORS.GRAY_LIGHT};
            cursor: default;
            pointer-events: none;

            @media (hover: hover) {
                &:hover {
                    border-color: ${COLORS.GRAY_LIGHT};
                }
            }
        }

        &:checked {
            border-color: ${ ({ invertColor }) => invertColor ? COLORS.BgSurface : COLORS.Control};
            background-color: ${ ({ invertColor }) => invertColor ? COLORS.BgSurface : COLORS.Control};

            &:after {
                content: '';
                position: absolute;
                top: -1px;
                left: -1px;
                width: calc(100% + ${BORDER_WIDTH}px);
                height: calc(100% + ${BORDER_WIDTH}px);
                background-color: ${ ({ invertColor }) => invertColor ? COLORS.Control : COLORS.BgMain};
                mask-image: url(${checkMark});
                mask-size: ${p => `${getCheckboxSizes(p.size).iconWidth}px ${getCheckboxSizes(p.size).iconHeight}px`};
                mask-position: center;
                mask-repeat: no-repeat;
            }

            @media (hover: hover) {
                &:hover {
                    border-color: ${COLORS.Link};
                    background-color: ${COLORS.Outline_Dark};
                }
            }

            &:disabled {
                border-color: ${COLORS.GRAY_LIGHT};
                background-color: ${COLORS.GRAY_LIGHT};
                pointer-events: none;

                &:after {
                    background-color: ${COLORS.GRAY_DARK};
                }
            }
        }

        ${({ size, checkType }) => checkType === 'promo' && css`
            border-color: ${COLORS.Brand_Blue};

            &:before {
                content: '';
                position: absolute;
                top: -1px;
                left: -1px;
                width: calc(100% + ${BORDER_WIDTH}px);
                height: calc(100% + ${BORDER_WIDTH}px);
                background-color: ${COLORS.Brand_Blue};
                mask-image: url(${promoMark});
                mask-size: ${getCheckboxSizes(size).promoIconSize}px;
                mask-position: center;
                mask-repeat: no-repeat;
            }

            @media (hover: hover) {
                &:hover {
                    border-color: ${COLORS.Link};
                    background-color: ${COLORS.Outline_Dark};

                    &:before {
                        background-color: ${COLORS.BgMain};
                    }
                }
            }

            &:required:invalid {
                &:before {
                    background-color: ${COLORS.Error};
                }
            }

            &:focus-visible {
                border-color: ${COLORS.Link};
                background-color: ${COLORS.Outline_Dark};

                &:before {
                    background-color: ${COLORS.BgMain};
                }
            }

            &:checked:before,
            &:required:invalid:hover:before {
                display: none;
            }

            &:disabled {
                border-color: ${COLORS.GRAY_LIGHT};
                background-color: ${COLORS.GRAY_LIGHT};
                pointer-events: none;

                &:before {
                    display: none;
                }

                @media (hover: hover) {
                    &:hover {
                        background-color: ${COLORS.GRAY_DARK};
                    }
                }
            }
        `};
    }
`;
